export default __webpack_public_path__ + "static/ShareSection1_us-6a901474abab8b7c846e3a1af91f6be9.png";